(function (module) {
    "use strict";

    module.component('chooseBudgetVersion', {
        template: require('./chooseBudgetVersionComponent.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: function () {
            var $ctrl: $TSFixMe = this;

            $ctrl.$onInit = () => {
                $ctrl.versions = $ctrl.resolve.versions;

                if ($ctrl.versions.length == 1) {
                    
                    $ctrl.selectedVersion = _.first($ctrl.versions);
                }
            };

            $ctrl.ok = function () {
                $ctrl.close({
                    $value: $ctrl.selectedVersion
                });
            };

            $ctrl.cancel = function () {
                $ctrl.dismiss({
                    $value: 'cancel'
                });
            };

        }
    })

})(angular.module('topline.modules'));